import React from "react";
import Image, { StaticImageData } from "next/image";
import Link from "next/link";
import { BsArrowUpRight } from "react-icons/bs";
import { BiCheck } from "react-icons/bi";

interface ProductCardProps {
  href: string;
  title: string;
  description?: string;
  list?: string[];
  image: StaticImageData | string;
}

const ProductCard: React.FC<ProductCardProps> = ({
  href,
  title,
  description,
  list = [],
  image,
}) => {
  return (
    <Link
      href={href}
      className="group relative flex h-full w-full flex-col overflow-hidden border border-gray-200/70 bg-white  shadow-[0_2px_20px_-8px_rgba(0,0,0,0.12)] transition-all duration-500 hover:-translate-y-1.5 hover:border-amber-300/60 hover:shadow-[0_24px_50px_-18px_rgba(245,158,11,0.35)] sm:flex-row sm:gap-2"
    >
      {/* Image: full height, inset, rounded */}
      <div className="relative aspect-[4/3] w-full shrink-0 overflow-hidden bg-black sm:aspect-auto sm:min-h-[280px] sm:w-[240px] sm:self-stretch lg:w-[260px]">
        <Image
          src={image}
          alt={title}
          fill
          className="object-cover transition-transform duration-700 ease-out group-hover:scale-110"
        />
        {/* Soft gradient overlay */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 via-transparent to-transparent" />

        
      </div>

      {/* Content */}
      <div className="flex flex-1 flex-col p-5 sm:p-6 gap-3">
        {/* Accent line */}
        <span className="mb-1 block h-1 w-10 rounded-full bg-gradient-to-r from-amber-500 to-orange-400 transition-all duration-500 group-hover:w-16" />

        <h3 className="text-xl font-bold tracking-tight text-gray-900 transition-colors duration-300 group-hover:text-amber-600 sm:text-2xl">
          {title}
        </h3>

        {description && (
          <p className="mt-3 line-clamp-3 text-sm leading-relaxed text-gray-500">
            {description}
          </p>
        )}

        

        {/* Bottom CTA – always pinned to bottom */}
        <div className="mt-auto flex items-center justify-between border-t border-gray-100 pt-5">
          <span className="text-sm font-semibold tracking-wide text-gray-900">
            View Product
          </span>
          <span className="flex h-10 w-10 items-center justify-center rounded-full bg-gray-900 text-white transition-all duration-300 group-hover:bg-gradient-to-br group-hover:from-amber-500 group-hover:to-orange-500 group-hover:shadow-lg group-hover:shadow-amber-500/30">
            <BsArrowUpRight
              size={14}
              className="transition-transform duration-300 group-hover:rotate-45"
            />
          </span>
        </div>
      </div>
    </Link>
  );
};

export default ProductCard;